import React from 'react';
const OnpageIcon = () => {
  return <svg width="18" height="19" viewBox="0 0 18 19" fill="#fff" xmlns="http://www.w3.org/2000/svg">
  <path d="M15.25 13.4229L16.8514 15.0243C17.494 15.6669 17.494 16.7088 16.8514 17.3513C16.2088 17.9939 15.167 17.9939 14.5244 17.3513L12.923 15.75M0.666687 8.24996C0.666687 4.33794 3.838 1.16663 7.75002 1.16663C11.662 1.16663 14.8334 4.33794 14.8334 8.24996C14.8334 12.162 11.662 15.3333 7.75002 15.3333C3.838 15.3333 0.666687 12.162 0.666687 8.24996Z" stroke="#5C5F62" fill='#fff' strokeWidth="1.25" strokeLinecap="round"/>
  </svg>
  
  
};

export default OnpageIcon;
